import { DateRange } from '@/dashboards/ModelContributions/components/ActionBar/DateRange';
import { CompetitorsMediaInvestmentSearch } from '@/dashboards/CompetitorsMediaInvestment';
import { Select, SelectRef } from '@/components/Select/Select';
import { PeriodOption } from '@/config/model';
import { capitalizeFirstLetter } from '@/utils/stringUtils';
import { Label } from 'flowbite-react';
import { useRef } from 'react';

interface FilterControlsProps {
    search: CompetitorsMediaInvestmentSearch;
    minDate: Date;
    maxDate: Date;
    tabsToRender: PeriodOption[] | undefined;
    vertical?: boolean;
    onSetSearch: (search: Partial<CompetitorsMediaInvestmentSearch>) => void;
    onPeriodChange: (period: PeriodOption) => void;
}

export const FilterControls = ({
    search,
    minDate,
    maxDate,
    tabsToRender,
    vertical = false,
    onSetSearch,
    onPeriodChange,
}: FilterControlsProps) => {
    const selectRef = useRef<SelectRef>(null);

    const dateRange = (
        <DateRange
            minDate={minDate}
            maxDate={maxDate}
            searchStartDate={search.startDate}
            searchEndDate={search.endDate}
            onSetSearch={onSetSearch}
        />
    );

    const periodSelect = (
        <div>
            <div className="mb-1 block">
                <Label
                    onClick={() => selectRef.current?.click?.()}
                    className="font-mono font-normal text-nowrap truncate"
                    htmlFor="periodicity"
                >
                    Period
                </Label>
            </div>
            <Select
                id="periodicity"
                triggerRef={selectRef}
                selectedValue={search.period}
                dismissOnClick
                compact
                onSelectChange={onPeriodChange}
                label="Periodicity"
            >
                {tabsToRender?.map((periodName) => (
                    <Select.Option
                        key={periodName}
                        label={capitalizeFirstLetter(periodName)}
                        value={periodName}
                    />
                ))}
            </Select>
        </div>
    );

    if (vertical) {
        return (
            <div className="flex flex-col gap-6 pt-2">
                {dateRange}
                {periodSelect}
            </div>
        );
    }

    return (
        <>
            <div className="flex gap-4">{dateRange}</div>
            {periodSelect}
        </>
    );
};
